const formatoMoeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const formatoValor = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const formatoAliquota = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

/** Valor em reais com o símbolo (6649.71 → "R$ 6.649,71"). */
export function formatarMoeda(valor: number): string {
  return formatoMoeda.format(valor);
}

/** Só o número, com 2 casas (6649.71 → "6.649,71"), para quando o "R$" fica num span à parte. */
export function formatarValor(valor: number): string {
  return formatoValor.format(valor);
}

/** Alíquota como a API envia, já em percentual (15 → "15"; 15.5 → "15,5"), sem o símbolo "%". */
export function formatarAliquota(valor: number): string {
  return formatoAliquota.format(valor);
}

/** Imposto de renda com a alíquota efetiva entre parênteses ("R$ 3.520,43 (15%)"). */
export function formatarImpostoComAliquota(valor: number, aliquota: number): string {
  return `${formatarMoeda(valor)} (${formatarAliquota(aliquota)}%)`;
}

/** Número com vírgula e `casas` casas fixas (2.5 → "2,50"; com 1 casa → "2,5"), sem separador de milhar. */
export function formatarDecimal(valor: number, casas = 2): string {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
    useGrouping: false,
  }).format(valor);
}

/** Lê um número digitado com vírgula ("2,5" → 2.5). Vazio ou inválido → null. */
export function lerDecimal(texto: string | null | undefined): number | null {
  const limpo = (texto ?? '').trim().replace(/\./g, '').replace(',', '.');
  if (!limpo) return null;
  const valor = Number(limpo);
  return Number.isFinite(valor) ? valor : null;
}

/** Lê um valor em reais ("R$ 6.087,87" → 6087.87), como sai da máscara 'moeda'. Vazio ou inválido → null. */
export function lerMoeda(texto: string | null | undefined): number | null {
  return lerDecimal((texto ?? '').replace(/R\$/g, '').replace(/\s/g, ''));
}
